import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import { ApproveBookingList } from "components/Admin/Calendar/ApproveBooking/ApproveBookingList";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";

const { loadSponsorBookings, showDeleteBookingsConfirmationModal } = actions;

const roles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "nurse", label: "Nurse" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
  // { value: "registered_general_nurses", label: "Registered General Nurse" },
];

class SponsorBookings extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.timer = true;
    this.state = {
      user_ids: [],
      page: props.page || 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
        period: "",
        booking_type: "",
        user_types: [],
        ...props.query,
      },
      startDate: null,
      endDate: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.total_pages != this.props.total_pages)
      this.setState({
        page: 1,
      });
  }

  componentWillMount = () => {
    this.updateUsersList();
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.updateUsersList
    );
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const searchQuery = {
      ...this.state.searchQuery,
      order: {
        [field]: order,
      },
    };
    this.setState(
      {
        searchQuery,
      },
      this.updateUsersList
    );
  };

  checkedUserIds = (user_id) => {
    var ids = _.assign(this.state.user_ids),
      index = this.state.user_ids.indexOf(user_id);

    if (index == -1) {
      ids.push(user_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ user_ids: [...ids] });
  };

  deleteBookings = () => {
    if (this.state.user_ids.length > 0) {
      this.props.deleteBookings(this.state.user_ids, this.state.searchQuery);
    }
  };

  changeFilterQuery = (e) => {
    const query = {
      ...this.state.searchQuery,
      ...{ [e.target.name]: e.target.value },
    };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  onDateRangeChange = (field, start, end) => {
    console.log(`${start} - ${end}`);
    const start_date = moment(start).format("YYYY/MM/DD");
    const end_date = moment(end).format("YYYY/MM/DD");

    const query = {
      ...this.state.searchQuery,
      ...{
        start_date: start,
        end_date: end,
        period: `${start_date} - ${end_date}`,
      },
    };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  onUserTypeChangeCalendar = (roles) => {
    const rolesValue = (roles || []).map((role) => role.value);

    const query = {
      ...this.state.searchQuery,
      ...{
        user_types: (roles || []).map((role) => role.value),
      },
    };

    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  updateUsersList = () => {
    console.log("update list");
    const { page, searchQuery } = this.state;
    this.props.loadSponsorBookings(searchQuery, page);
  };

  render() {
    const { deleteBookings } = this;
    return (
      <main className="site--width container_statistics">
        <div className="admin_calendar_table admin_table">
          <ApproveBookingList
            onOrderChange={this.onOrderChange}
            query={this.state.searchQuery}
            checkedUserIds={this.checkedUserIds}
            user_ids={this.state.user_ids}
            bookings={this.props.bookings}
            onDateRangeChange={this.onDateRangeChange}
            onUserTypeChangeCalendar={this.onUserTypeChangeCalendar}
            changeFilterQuery={this.changeFilterQuery}
            deleteBookings={deleteBookings}
            isSponsor={true}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.props.page,
              total_pages: this.props.total_pages,
            }}
            // onBookingApprove={this.onDisciplineApprove}
            // onBookingReject={this.onDisciplineReject}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookings: state.bookings.sponsorBookings.values,
    count: state.bookings.sponsorBookings.count,
    total_pages: state.bookings.sponsorBookings.pages,
    page: state.bookings.sponsorBookings.page,
    query: state.bookings.sponsorBookings.query || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    loadSponsorBookings: (query, page) =>
      dispatch(loadSponsorBookings(query, page)),
    deleteBookings: (booking_ids, query) =>
      dispatch(showDeleteBookingsConfirmationModal(booking_ids, query)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SponsorBookings);



// WEBPACK FOOTER //
// ./src/containers/Calendar/SponsorBookings.jsx